export const SHOW_NOTIFICATION = "@Overlay_ShowNotification";
export const HIDE_NOTIFICATION = "@Overlay_HideNotification";



// WEBPACK FOOTER //
// ./src/app/stores/reducers/notification/ActionsNotificationReducer.ts